import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
const relatedLinks = [{
  title: 'Mini Troopers (Ages 3-5)',
  href: '/mini-troopers',
  description: 'Our preschool-friendly program for the youngest students.'
}, {
  title: 'Kids Classes',
  href: '/karate-kids-classes.html',
  description: "The core children's Taekwondo program at Storm."
}, {
  title: 'Kids Martial Arts',
  href: '/kids-martial-arts-classes-in-farmington-hills-michigan',
  description: 'Searching "kids martial arts"? Start here.'
}, {
  title: 'Kids Karate Search',
  href: '/kids-karate-classes-in-farmington-hills-michigan',
  description: 'Looking for "kids karate"? Storm teaches Taekwondo.'
}, {
  title: 'Programs Overview',
  href: '/Programs.html',
  description: 'See every class and program Storm offers.'
}, {
  title: 'Start a Trial Class',
  href: '/SignMeUp',
  description: 'Pick a starting class and visit Storm.'
}];
export function KidsTaekwondoRelatedLinks() {
  return <section className="py-20 bg-off-white border-t border-subtle-gray" data-id="element-2235">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2236">
        <h2 className="text-3xl md:text-4xl text-ink text-center mb-12" data-id="element-2237">
          Related Classes & Programs
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-2238">
          {relatedLinks.map(link => <Link key={link.href} to={link.href} className="group bg-paper border border-subtle-gray hover:border-storm-red rounded-2xl p-6 transition-all flex items-start justify-between gap-4" data-id="element-2239">
              <div data-id="element-2240">
                <p className="font-bold text-ink text-lg mb-1" data-id="element-2241">{link.title}</p>
                {link.description && <p className="text-sm text-gray-warm" data-id="element-2242">{link.description}</p>}
              </div>
              <ArrowRight className="w-5 h-5 text-storm-red shrink-0 mt-1 group-hover:translate-x-1 transition-transform" data-id="element-2243" />
            </Link>)}
        </div>
      </div>
    </section>;
}